<template>
  <v-col :cols="12" :sm="model.cols" class="pa-0">
    <v-card class="ma-2" :color="model.color" :dark="model.dark" :light="!model.dark">
      <v-card-actions v-if="model.id">
        <v-icon class="handle">mdi-drag</v-icon>
        <v-spacer></v-spacer>
        <v-btn icon v-if="model.level == '2'" @click="$emit('edit',model)">
          <v-icon>mdi-folder-edit</v-icon>
        </v-btn>
        <v-btn icon v-if="model.level == '1'" @click="addChild">
          <v-icon>mdi-folder-plus</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-title :class="model.titleClass" v-text="model.title"></v-card-title>
      <v-card-text v-if="model.level < 2" >
        <dnd-container
          class="row row--dense"
          :style="{minHeight:'50px',border:model.dark ? '1px dotted white' : '1px dotted black'}"
          :dnd-id="model.id"
          :dnd-model="model.children"
          :container-transfer="{level:model.level}"
          :vertical-search="$vuetify.breakpoint.xs"
        >
          <template v-for="child in model.children">
            <dnd-item :key="child.id" :dnd-id="child.id" :dnd-model="child">
              <recursive-grid :model="child" @addChild="addChild" @edit="edit"/>
            </dnd-item>
          </template>
        </dnd-container>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
  export default {
    name: 'RecursiveGrid',
    props:['model'],
    data: () => ({
    }),
    methods:{
      edit(model){
        if (model.id){
          this.$emit('edit',model)
        }else{
          this.$emit('edit',this.model)
        }
      },
      addChild(model){
        if (model.id){
          this.$emit('addChild',model)
        }else{
          this.$emit('addChild',this.model)
        }
      }
    }
  }
</script>
